import { BRAND_HEX } from '../../styles/brand-colors';
import type { InputFieldVariantProps } from './Input.variants';

type Size = NonNullable<InputFieldVariantProps['size']>;

/**
 * Slot-icon size per input size (Figma icon cells 3368:6417 / 6320 / 5539 /
 * 5298 / 6268): 18px through `l`, 20px from `xl` — tracking the B2→B1 text
 * step.
 */
export const ICON_SIZE_FOR: Record<Size, number> = {
  s: 18,
  m: 18,
  l: 18,
  xl: 20,
  xxl: 20,
};

/**
 * Slot-icon color — `secondary-500` (#737373) in the Figma cells. 500 is the
 * fixed midpoint of the auto-inverting ramp, so the hex is identical in dark
 * mode; returned as hex because `lucide-react-native` reads `color` as a
 * prop, not a className.
 */
export function resolveInputIconColor(): string {
  return BRAND_HEX.secondary['500'];
}

/**
 * Native placeholder color per (focused, dark). Web handles this via
 * `placeholder:` classes; RN needs the resolved hex on the
 * `placeholderTextColor` prop. Rest = secondary-400 (dark inverts to the
 * secondary-600 hex); focused = the fixed secondary-500.
 */
export function resolveInputPlaceholderColor(focused: boolean, isDark: boolean): string {
  if (focused) return BRAND_HEX.secondary['500'];
  return isDark ? BRAND_HEX.secondary['600'] : BRAND_HEX.secondary['400'];
}
